// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  'Campaign progress job is running in background':
    'Cert.Campaignprogressjobisrunninginbackground.label',
  'Progress is being updated': 'Cert.Progressisbeingupdated.label',
  'Open menu': 'certs.open.menu',
  More: 'CERTS_BULK_MORE',
  'All Actions': 'certs.all.actions',
};
